import { render, staticRenderFns } from "./menuForm.vue?vue&type=template&id=49fd5460&scoped=true&"
import script from "./menuForm.vue?vue&type=script&lang=js&"
export * from "./menuForm.vue?vue&type=script&lang=js&"
import style0 from "./menuForm.vue?vue&type=style&index=0&id=49fd5460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd5460",
  null
  
)

export default component.exports